<script lang="ts">
  import ShortcutTable from '../components/ShortcutTable.svelte';
</script>

<div class="page page-narrow">
  <section class="panel" aria-labelledby="keys-page-title">
    <h1 id="keys-page-title" tabindex="-1">ショートカット</h1>
    <ShortcutTable />
  </section>
</div>

<style>
  h1 {
    margin-bottom: var(--space-4);
  }
</style>
